<template>
  <div class="container-fluid">
    <h1 class="detail-title">
      <i id="sidebar" class="fa fa-bars sidebar" @click="toggleSidebar"></i>
      Create Organization
    </h1>
    <div id="card">
      <div class="card-section">
        <popups></popups>
        <div class="row section-body">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Name</p>
            <input id="organization-name" type="text" name="name" />
          </div>
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">State</p>
            <select id="organization-status" name="status" class="section-property">
              <option v-for="option in status_options"
                  :selected="option.default? 'selected' : ''"
                  :value="option.name" >{{ option.name | capitalize }}
              </option>
            </select>
          </div>
        </div>
        <div class="row section-body">
          <div class="col-sm-6 section-property-block">
            <p class="section-property-title">Address</p>
            <textarea id="organization-address" type="text" name="address"></textarea>
          </div>
        </div>
      </div>

      <div class="card-section sub-section">
        <div class="row">
          <div class="col-sm-3">
            <h1 class="section-title">Contact Methods</h1>
          </div>
        </div>
        <div class="row section-body contact" v-for="(contact, index) in contact_fields">
          <div class="col-sm-3 section-property-block" v-for="field in contact">
            <p class="section-property-title">{{ field | capitalize }}</p>
            <select v-if="field === 'contact_method'" :id="'contact_method-'+ index"
                  :ref="'contact_method-'+ index"
                  :name="field+'-'+index" class="section-property">
              <option value="">Select A Contact Method</option>
              <option v-for="option in contact_options"
                  :value="option">{{ option | capitalize }}
              </option>
            </select>
            <input v-else :id="'value-'+ index" :ref="'value-'+ index"
                type="text" :name="field+ '-'+index"
                placeholder="Enter value"/>
          </div>
          <div class="col-sm-4" v-if="index < 1">
            <div class="col-sm-2" v-if="!hasExceeded">
                <div class="plus" @click="toggleContact('add')">
                  <img src="../../assets/plus.svg" alt="">
                </div>
            </div>
            <div class="col-sm-2" v-if="hasMultiple">
                <div class="minus" @click="toggleContact('remove')">
                  <img src="../../assets/letter-x.svg" alt="">
                </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-section sub-section">
        <div class="row section-body button">
          <div class="col-sm-3 section-property-block">
            <btn type="primary" @click="submitOrganization()">Create</btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import constants from '../../constants';
import store from '../../store.js';
import { bus } from '../../main';
import Vue from 'vue';
import Popups from '../Popups';

export default {
  data () {
      return {
        errors: [],
        hasMultiple: false,
        hasExceeded: false,
        message: { type: 'warning', title: 'Organization' },
        contact_fields: [['contact_method', 'value']],
        status_options: [{'name': 'active', 'default': true},
                         {'name': 'inactive', 'default': false}],
        contact_options: ['email', 'fax', 'telephone', 'website'],
      };
  },
  computed: {
    ...mapGetters([ 'hasErrors', 'getErrors' ]),
    ...mapState({
      // Extract things like this out into a Mixin
      selectedOrganization: function(state) {
        return [];
      },
    }),
  },
  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    },

    redirect: function(action) {
      if (action == 'success') this.$router.push('/organizations');
    },

    reset: function() {
      this.errors = [];
      bus.$emit('reset', {});
    },

    trimValue: function(value) {
      return (value != undefined || value != null)? value.trim() : value;
    },

    resetTemplate: function() {
      this.clearFields(document.getElementById('card'));
    },

    showPopup: function(value, type) {
      bus.$emit(type, { data: value });
      this.redirect(value.type)
    },

    clearFields: function(element) {
      for (var i = 0; i < element.childNodes.length; i++) {
         var e = element.childNodes[i];
         if (e.tagName) switch (e.tagName.toLowerCase()) {
            case 'input':
               switch (e.type) {
                  case "radio":
                  case "checkbox": e.checked = false; break;
                  case "button":
                  case "submit":
                  case "image": break;
                  default: e.value = ''; break;
               }
               break;
            case 'select': e.selectedIndex = 0; break;
            case 'textarea': e.value = ''; break
            default: this.clearFields(e);
         }
      }
    },

    createOrganization: async function(data) {
      this.reset();

      let failed = constants.message.create.failed;
      let success = constants.message.create.success;
      let response  = await store.dispatch('createOrganization', { organization: data });

      if(response != null){
        this.message.type = 'success';
        this.message.content = success;
      } else this.message.content = failed;
      this.showPopup(this.message, 'notification');
    },

    submitOrganization: function() {
      this.reset();
      let _errors=this.errors

      let contacts = [];
      let name = $("#organization-name").val();
      let address = $("#organization-address").val();
      let status = $("#organization-status option:selected").val();
      let re = /^(([a-zA-Z0-9]+)|([a-zA-Z0-9]+((?:\_[a-zA-Z0-9]+)|(?:\.[a-zA-Z0-9]+))*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-zA-Z]{2,6}(?:\.[a-zA-Z]{2})?)$)/;

      if (name.length === 0)
        this.errors.push('Name is required');
      if (address.length === 0)
        this.errors.push('Address is required');

      $('.contact').each(function(i, obj) {
        let value = this.querySelector("input[name=value-"+i+"]").value;
        let category = $("#contact_method-" +i+" option:selected").val();
        if (category.length > 0 && value.length > 0 && category=="email"){
          if (re.test(value)==true){
              contacts.push({'category': category, 'value': value});
              console.log("good job");
            }
            else {
              _errors.push('Incorrect email format for contact information');
            }
          }
        else if (category.length > 0 && value.length > 0 && category!="email") {
            contacts.push({'category': category, 'value': value});
          }
      });
      this.errors.concat(_errors);
      console.log(this.errors);

      if (this.errors.length > 0) this.showPopup({'content': this.errors }, 'alert');
      else {
        this.createOrganization({
          'name': this.trimValue(name),
          'address': this.trimValue(address),
          'status': status, 'contacts': contacts});
      }
    },

    toggleContact: function (action) {
      var count = this.contact_fields.length;
      if (action == 'add') {
        if (count < 6) {
          this.contact_fields.push(['contact_method', 'value']);
          count += 1;
        }
        if (count >= 6) this.hasExceeded = true;
      } else {
          if (count > 1) {
            this.contact_fields.pop();
            count -= 1;
            if (this.hasExceeded) this.hasExceeded = false;
          }
        }
      this.hasMultiple = (count > 1)? true : false;
    },
  },
  components: {
    Popups
  },
  beforeRouteEnter (to, from, next) {
    next();
  },

  beforeDestroy () {
    store.dispatch('resetErrors');
  },
};
</script>

<style scoped lang="scss">
@import "../../css/constants";
input, textarea, select { outline: none; border: none; }

input:not([disabled]):active,
input:not([disabled]):focus,
input:not([disabled]) {
  width:100%;
  border-bottom: 1px solid #c3c3c3;
}

h1.detail-title{
  background-color: #04bafc;
  padding: 20px;
  margin-left: -40px;
  margin-right: -40px;
  color: white;
  height: auto;
  margin-bottom: 25px;

  i {
    cursor: pointer;
    display: none;
    font-size: 1.3em;
    margin-top: -4px;
    vertical-align: middle;
    text-shadow:  0px 1px 1px rgba(0, 0, 0, 0.1);

    &:hover {
      color: #f1f1f1;
    }
  }
}

/* body select.select_box */
select {
  display: block;
  padding: 6px 0px !important;
  max-width: 100%;
  height: auto !important;
  border: none !important;
  border-radius: 0px;
  background: transparent;
  border-bottom: 1px solid #c3c3c3 !important;

  font-size: 16px;
  line-height: 16px !important;
  appearance: none; /* this is must */
  -webkit-appearance: none;
  -moz-appearance: none;
}

/* body select.select_box option */
body select option { padding: 0 4px; }
/* for IE and Edge */
select::-ms-expand { display: none; }
select:disabled::-ms-expand { background: #f60; }
textarea {
    width: 100%;
    max-width: 100%;
    min-width: 60%;
    height: 50px;
    max-height: 50px;
    min-height: 50px;
    border-bottom: 1px solid #c3c3c3;
    padding: 0;
    overflow: auto;
}
.tool-tip{
  display: none;
  color: grey;
  background-color: #ececec;
  border-radius: 4px;
  position:absolute;
  margin-top: -40px;
  width: fit-content;
  padding-top:5px;
  padding-bottom:5px;
  padding-left: 5px;
  padding-right:5px;
  z-index: 100;
}
.tool-tip::after{
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #ececec transparent transparent transparent;
}
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.section-property:hover{
  display: block;
}
.container-fluid {
    padding: auto;
}
.card-section {
  display: flex;
  flex-direction: column;
}

.sub-section {
  margin-top: 25px;
}
.col-padding { margin-bottom: 20px; }
.card-sub-body {
  margin-top: 20px !important;
  border-top: 1px solid #ddd;
  padding: 25px 0 0 0;
}

.section-body {
  display: flex;
  flex-wrap: wrap;
}
.section-title {
    color: $gray7;
    font-size: $p20;
    line-height: $p20;
    margin-bottom: $p24;
}
.section-property-block {
  margin-right: $p16;
	margin-bottom: $p16;
	// min-width: 140px;
}
.section-property-title {
    position:relative;
    z-index:1;
    color: $gray5;
    text-transform: uppercase;
    margin-bottom: $p16;
    font-size: $p14;
    line-height: $p14;
}
.section-property-container {
  height: $p32;
}
.section-property {
    color: $gray7;
    border:none;
    word-wrap: break-word;
    cursor: pointer;
    width: 100%;
}

.hor-padding{ display: block; margin-right: 110px !important; }
.detail-card-body{
    background-color: white;

}
@media (min-width: 576px){
  .col-sm-2 {
    max-width: 15.666667%;
  }
}
//Reset Grid
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4,
.col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10,
.col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6,
.col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12,
.col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8,
.col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3,
.col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  padding: 0 0 5px 0;
}
//Reset row
.row {
  margin: 0;
}
.minus, .plus{
  border: 1px solid #cfcfcf;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: flex;
  margin-top: 5px;
  cursor: pointer;
  margin-top: 30px;
  margin-left: 10px;
}

.minus > img, .plus > img{
  margin: auto;
}

  button.save {
    width: 100px;
    height: $p32;
    border: 1px solid $gray4;
    border-radius: 4px;
    background-color: white;
    font-size: $p14;
    color:grey;
    &:focus {
      outline: none;
    }
  }

  @media only screen and (min-width: 768px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
    }
  }

  @media only screen and (min-width: 468px) and (max-width: 768px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
      i { display: inline-block; margin-right: 15px;  }
    }
  }

  @media only screen and (max-width: 467px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
      i { display: inline-block; margin-right: 15px; }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/organization/OrganizationCreate.vue